// components/ModalIntervention.js

import React, { useEffect, useId } from 'react';
import DevisForm from '../../components/DevisForm';
import Logo from '../../assets/logo.png';

const ModalIntervention = ({ isOpen, onClose, questions }) => {
  const titleId = useId();
  const descriptionId = useId();

  // Fermeture avec la touche Échap
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
    >
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Fermer la demande d'intervention"
        >
          ×
        </button>

        <div className="modal-text">
          <img
            src={Logo}
            alt=""
            className="modal-logo"
            aria-hidden="true"
          />

          <h2 id={titleId}>
            Demander une intervention ou un devis
          </h2>

          <p id={descriptionId}>
            Besoin d’un dépannage, d’un devis ou vous avez un projet d’installation
            ou de rénovation ?
            <br />
            Décrivez-nous votre besoin en quelques minutes, nous revenons rapidement vers vous.
          </p>
        </div>

        <DevisForm questions={questions} />
      </div>
    </div>
  );
};

export default ModalIntervention;